module.exports = __webpack_public_path__ + "img/courses.ba61a426.svg";